export default "__VITE_ASSET__DmoEALjk__"